import { Component, OnInit, Input } from '@angular/core';
import { Attachment } from '../attachment/attachment';
import { Authenticate } from '../authenticate/authenticate';
import { AttachmentService } from './attachmentservice';
import { User } from '../user/user';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.less', '../app.component.less']
})

export class AttachmentComponent implements OnInit {
  @Input() attachments: Attachment[];
  @Input() _currentUser: User;
  @Input() ticketid: number;
  auth: Authenticate;
  isAdmin = true;
  ff: any;
  formData: FormData;

  constructor(private attachmentservice: AttachmentService) { }

  // LOAD PAGE 
  ngOnInit() {
    if (this._currentUser.privilege == "3") { this.isAdmin = false }
  }

  // IF UPLOAD FILE CHANGED
  onFileChanged(event) {
    const thisfile = event.target.files[0];
    this.formData = new FormData();
    console.log(thisfile.name);

    this.formData.append('files', thisfile);
    this.formData.append('testvalue', 'my test value');

    this.formData.forEach((value, key) => {
      console.log(key + " " + value)
    });
    var reader = new FileReader();
    reader.onload = (event: any) => {
      var im = document.getElementById("AV");
      im.setAttribute('src', event.target.result);
      this.ff = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
  }

  // VIEW ATTACHMENT
  viewAtt(arg: string, attmime: string) {
    var im = document.getElementById("viewimage");
    var av = document.getElementById("AV");
    var all = document.getElementById("allviews");
    all.style.display = 'block';
    if (attmime.includes('image')) {
      // av.style.display= 'none';
      // im.setAttribute('src',arg);
      //im.style.display = 'block';
      window.open(arg, "popup", "width=600,height=400");
    }
    if (attmime.includes('video') || attmime.includes('aud')) {
      im.style.display = 'none';

      av.setAttribute('src', arg);
      av.style.display = 'block';

    }

    if (attmime.includes('application')) {
      window.open(arg, "popup", "width=600,height=400");
    }
    if (attmime.includes('text')) {
      window.open(arg, "popup", "width=600,height=400");
    }
  }

  // HIDE VIEW
  hideViews() {
    var im = document.getElementById("viewimage");
    var av = document.getElementById("AV");
    im.style.display = 'none';
    av.style.display = 'none';
    var all = document.getElementById("allviews");
    all.style.display = 'none';
  }

  // DELETE ATTACHMENT 
  deleteAttachment(attachment: Attachment, i: number) {
    this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
    let jwt = this.auth.jwt;
    if (confirm("Are you sure to delete this attachment?")) {
      this.attachmentservice.deleteAttachment(attachment, jwt).subscribe(any => {
        this.attachments.splice(i, 1);
      });
      this.attachmentservice.deleteUpload(attachment, jwt).subscribe(result => console.log(result));
    }
  }

  // UPLOAD ATTACHMENT 
  uploadAttachUrl() {
    this.attachmentservice.addAttachUrl(this.formData).subscribe(response => {

      var attrep = new Attachment;
      attrep.url = response[0].url;
      attrep.mime = response[0].mime;
      attrep.name = response[0].name;
      attrep.size = response[0].size;
      attrep.refId = response[0].id;

      this.attachmentservice.addAttach(environment.appURL + attrep.url,
        this.ticketid,
        this._currentUser.id,
        attrep.mime,
        attrep.name,
        attrep.size, attrep.refId
      ).subscribe(response => {
        this.attachments.push(response);
        var im = document.getElementById("AV");
        im.setAttribute('src', '');
      });
    });
  }
}
